import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DASHBOARDTASK, TASK } from "services/apiEndpoints";
import { privateGet } from "services/privateRequest";
import { homeTabNames } from "utils/constants";
import { makeQueryString } from "utils/utils";

const initialState = {
    data: homeTabNames.reduce((acc, tab) => {
        acc[tab] = []
        return acc
    }, {}),
    isFetching: false,
    activeTab: 0,
    sidebarOpen: false,
    tasks: [],
    teamFilter : "",
    totalTasks: 0,
    status: "idle",
    notification: false
}
export const getTaskList = createAsyncThunk(
    "task/getTaskData",
    async (payload) => {
        const queryString = makeQueryString(DASHBOARDTASK, payload);
        const res = await privateGet(queryString);
        return {
            data: res?.data?.data[0] || [],
            totalTasks: res?.data?.data?.totalResponses || 0,
        };
    }
);

const homeSlice = createSlice({
    name: "home",
    initialState,
    reducers: {
        setIsFetching: (state, action) => {
            state.isFetching = action.payload
        },
        setActiveTab: (state, action) => {
            state.activeTab = action.payload
        },
        setSidebarOpen: (state, action) => {
            state.sidebarOpen = action.payload
        },
        setNotification: (state, action) => {
            state.notification = action.payload
        },
        setTeamFilter: (state, action) => {
            state.teamFilter = action.payload
        },
        clear: () => initialState,
    },
    extraReducers: {
        [getTaskList.pending]: (state) => {
            state.status = "loading";
        },
        [getTaskList.rejected]: (state) => {
            state.status = "error";
            state.tasks = [];
            state.totalTasks = 0;
        },
        [getTaskList.fulfilled]: (state, action) => {
            console.log('action.payload', action.payload)
            state.status = "idle";
            state.tasks = action.payload.data;
            state.totalTasks = action.payload.totalTasks;
        },
    },
})

export default homeSlice.reducer
export const { setIsFetching, setNotification, setActiveTab, setSidebarOpen, setTeamFilter ,clear } = homeSlice.actions